const getNounPluralForm = (num: number) => {
  if (num % 10 === 1 && num % 100 !== 11) {
    return 0;
  } else if (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)) {
    return 1;
  } else {
    return 2;
  }
};

export const pluralize = (num: number, forms: [string, string, string?]) => {
  if (forms.length === 2) {
    return num > 1 ? forms[1] : forms[0];
  }

  return forms[getNounPluralForm(num)];
};
